// https://gitlab.com/tezos-domains/client
import { TezosToolkit } from '@taquito/taquito';
import { TaquitoTezosDomainsClient } from '@tezos-domains/taquito-client';
import { Tzip16Module, DEFAULT_HANDLERS, MetadataProvider, IpfsHttpHandler } from '@taquito/tzip16';
import { Injectable } from '@angular/core';
import { CONSTANTS } from '../../../environments/environment';
import { SupportedNetworkType } from '@tezos-domains/core';
import { IPFS_GATEWAY } from '../../libraries/ipfs';

@Injectable({
  providedIn: 'root'
})
export class TezosDomainsService {
  private client: TaquitoTezosDomainsClient;
  unsupportedNetwork = false;
  private queue = [];
  pending = false;
  constructor() {
    const tezosToolkit = new TezosToolkit(CONSTANTS.NODE_URL[0]);
    const handlers = new Map(DEFAULT_HANDLERS);
    handlers.set('ipfs', new IpfsHttpHandler(IPFS_GATEWAY));
    tezosToolkit.addExtension(new Tzip16Module(new MetadataProvider(handlers)));
    const options = { caching: { enabled: false } };
    try {
      this.client = new TaquitoTezosDomainsClient({
        tezos: tezosToolkit,
        network: <SupportedNetworkType>CONSTANTS.NETWORK,
        ...options
      });
    } catch (e) {
      if (e?.message && e.message.includes('Supported built-in networks are:') && !CONSTANTS.MAINNET) {
        console.warn(`Tezos Domains disabled: no built-in configuration for network ${CONSTANTS.NETWORK}`);
        this.unsupportedNetwork = true;
      } else {
        throw e;
      }
    }
  }
  async getAddressFromDomain(domain: string) {
    if (this.unsupportedNetwork) {
      return { pkh: '' };
    }
    const address = await this.client.resolver.resolveNameToAddress(domain);
    if (!address) {
      return { pkh: '' };
    }
    return { pkh: address };
  }
  async getDomainFromAddress(address: string): Promise<string> {
    if (!this.pending) {
      this.pending = true;
      this.collect();
    }
    return new Promise((resolve, reject) => {
      this.queue.push({ address, resolve, reject });
    });
  }
  async collect() {
    setTimeout(async () => {
      this.pending = false;
      const queue = this.queue;
      this.queue = [];
      const addresses = queue.map((q) => {
        return q.address;
      });
      const items = await this.getDomainFromAddresses(addresses).catch((e) => {
        for (const q of queue) {
          q.reject(e);
          throw e;
        }
      });
      while (queue.length) {
        const promise = queue.shift();
        if (items[promise.address]) {
          promise.resolve(items[promise.address]);
        } else {
          promise.resolve('');
        }
      }
    }, 100);
  }
  async getDomainFromAddresses(addresses: any) {
    if (this.unsupportedNetwork) {
      return {};
    }
    const baseUrl = CONSTANTS.MAINNET ? 'https://api.tezos.domains/graphql' : `https://${CONSTANTS.NETWORK}-api.tezos.domains/graphql`;
    const req = {
      query: `{reverseRecords(where: {address: {in: ${JSON.stringify(addresses)}}}) {items {address domain: domain {id, name}}}}`
    };
    const response = await (
      await fetch(baseUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      })
    ).json();
    const r = {};
    if (response.data) {
      for (const item of response.data.reverseRecords.items) {
        if (item?.address && item?.domain?.name) {
          r[item.address] = item.domain.name;
        }
      }
    }
    return r;
  }
}
